import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-button-add',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule, TranslateModule],
  templateUrl: './button-add.component.html',
  styleUrls: ['./button-add.component.scss'],
})
export class ButtonAddComponent {
  @Input() captionT?: string;
  @Input() caption?: string;

  @Input() color = 'primary';
  @Input() disabled = false;

  constructor(private translateService: TranslateService) {}

  get captionInternal() {
    if (this.caption) {
      return this.caption;
    }
    if (this.captionT) {
      return this.translateService.instant(this.captionT);
    }
    return '';
  }
}
